uniform vec3 uColorLow;
uniform vec3 uColorHigh;

varying vec2 vUv;
varying float vWobble;

#include ../includes/simplexNoise4d.glsl
void main()
{
    float colorMix = smoothstep(- 1.0, 1.0, vWobble);
    csm_DiffuseColor.rgb = mix(uColorLow, uColorHigh, colorMix);
}